import { memo } from 'react';
import type { FieldWithLabelAndInputPT } from '@shared/ui/forms/FieldWithLabel/FieldWithLabelAndCard/types';
import { FormFieldWithLabelAndNumberInput } from '@shared/ui/forms/FieldWithLabel/index';
import { SelectPaymentMethod } from '@shared/ui/inputs/select/SelectPaymentMethod/ui.tsx';
import { type SelectPT } from '@shared/ui/inputs/select/ui.tsx';
import * as st from './styles.module.scss';

type FormCost = Omit<FieldWithLabelAndInputPT, 'fieldLabel'> & {
  withCostPaymentMethod?: SelectPT;
};
export const FormCost = memo(({ withCostPaymentMethod, ...props }: FormCost) => {
  return (
    <FormFieldWithLabelAndNumberInput
      requiredField={props.required}
      fieldLabel={'Стоимость'}
      suffix={'RUB'}
      className={st.formCost}
      {...props}
    >
      {withCostPaymentMethod && <SelectPaymentMethod {...withCostPaymentMethod} />}
    </FormFieldWithLabelAndNumberInput>
  );
});
